export const endpointBaseURL = process.env.REACT_APP_EndpointBaseURL;

export const azureEndpointBaseURL = process.env.REACT_APP_AzureEndpointBaseURL;

export const paymentEndpointBaseURL = process.env.REACT_APP_PaymentEndpointBaseURL;

export const websiteURL = process.env.REACT_APP_Environment === "production" ? "https://rosenau.ca" : "https://rosenaudev.flywheelsites.com";
